import type { ReactElement } from 'react';

/**
 * Statusmarke mit Text und Farbe (§21).
 *
 * §21 verbietet ausdrücklich rein farbbasierte Informationsvermittlung. Deshalb trägt jede Marke
 * **immer** ihre Beschriftung; die Farbe ist eine Zugabe, kein Träger der Aussage.
 */

export type Tonart = 'neutral' | 'aktiv' | 'erfolg' | 'warnung' | 'fehler';

const KLASSEN: Record<Tonart, string> = {
  neutral: 'bg-flaeche-gedaempft text-text-gedaempft',
  aktiv: 'bg-akzent/15 text-akzent',
  erfolg: 'bg-erfolg/15 text-erfolg',
  warnung: 'bg-warnung/15 text-warnung',
  fehler: 'bg-fehler/15 text-fehler',
};

export function StatusZeichen({
  beschriftung,
  tonart = 'neutral',
}: {
  beschriftung: string;
  tonart?: Tonart;
}): ReactElement {
  return (
    <span className={`rounded px-2 py-0.5 text-xs font-medium ${KLASSEN[tonart]}`}>
      {beschriftung}
    </span>
  );
}
